import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { Provider } from "react-redux";

import store from "./Reducers/store";

import "./Assets/fonts/index.css";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

const basePath = "aina/";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const router = createBrowserRouter([
  {
    path: `${basePath}`,
    element: <App />,
  },
  {
    path: `${basePath}sound_to_sight`,
    element: <App param={"sound_to_sight"} />,
  },
  {
    path: `${basePath}transformer`,
    element: <App param={"transformer"} />,
  },
  {
    path: `${basePath}responsible_ai`,
    element: <App param={"responsible_ai"} />,
  },
  {
    path: `${basePath}turf`,
    element: <App param={"turf"} />,
  },
  {
    path: "*",
    element: <App />,
  },
]);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);
